export enum MenuItemIcon {
  NONE = '',
  ROOT_FOLDER = 'fa-solid fa-folder',
  MACHINE = 'fa-solid fa-gears',
  MACHINE_GROUP = 'fa-solid fa-folder',
  NODE = 'fa-solid fa-folder',
  USER_DEFINED_PAGE = 'fa-solid fa-table-cells',
  INTERACTIVE_DATA_ANALYSIS = 'fa-solid fa-magnifying-glass-chart',
  EXTERNAL_URL = 'fa-solid fa-arrow-up-right-from-square',
  FORM_PAGE = 'fa-solid fa-file-circle-plus',
  TABLEAU_PAGE = 'fa-solid fa-chart-pie',
  FRAME_PAGE = 'fa-solid fa-square-arrow-up-right',
  WEBGL_PAGE = 'fa-solid fa-cube',
  BUCKET_BROWSER_PAGE = 'fa-solid fa-window-maximize',
  STATUS_EVENT_PAGE = 'fa-solid fa-triangle-exclamation',
  TEMPLATE_STATUS_EVENT_PAGE = 'fa-solid fa-triangle-exclamation corner-icon template-page',
  USER_SHARED_PAGE = 'fa-solid fa-table-cells corner-icon shared-page',
  TEMPLATE_USER_DEFINED_PAGE = 'fa-solid fa-table-cells corner-icon template-page',
}
